// Generated by scripts/gen-emoji3d.py: the emoji that have a 3D picture in public/emoji3d.
// Pictures: Microsoft Fluent Emoji 3D, MIT licence (public/emoji3d/LICENSE.txt).
export const EMOJI_3D: ReadonlySet<string> = new Set([
  '1f308',
  '1f30d',
  '1f319',
  '1f31f',
  '1f320',
  '1f331',
  '1f337',
  '1f338',
  '1f339',
  '1f33a',
  '1f33b',
  '1f33c',
  '1f340',
  '1f341',
  '1f342',
  '1f344',
  '1f345',
  '1f347',
  '1f349',
  '1f34c',
  '1f34d',
  '1f351',
  '1f352',
  '1f353',
  '1f366',
  '1f368',
  '1f369',
  '1f36a',
  '1f36b',
  '1f36c',
  '1f36d',
  '1f36f',
  '1f370',
  '1f375',
  '1f376',
  '1f377',
  '1f378',
  '1f379',
  '1f37a',
  '1f37b',
  '1f37c',
  '1f37e',
  '1f37f',
  '1f380',
  '1f381',
  '1f382',
  '1f383',
  '1f384',
  '1f386',
  '1f387',
  '1f388',
  '1f389',
  '1f38a',
  '1f393',
  '1f397',
  '1f3a4',
  '1f3a7',
  '1f3a9',
  '1f3ac',
  '1f3ae',
  '1f3b0',
  '1f3b2',
  '1f3b5',
  '1f3b6',
  '1f3b8',
  '1f3c0',
  '1f3c6',
  '1f3ce',
  '1f3ee',
  '1f3f0',
  '1f40c',
  '1f422',
  '1f427',
  '1f428',
  '1f42c',
  '1f42d',
  '1f430',
  '1f431',
  '1f435',
  '1f436',
  '1f438',
  '1f439',
  '1f43c',
  '1f44d',
  '1f44f',
  '1f451',
  '1f452',
  '1f453',
  '1f45b',
  '1f47b',
  '1f480',
  '1f483',
  '1f484',
  '1f48b',
  '1f48c',
  '1f48d',
  '1f48e',
  '1f490',
  '1f495',
  '1f496',
  '1f497',
  '1f498',
  '1f49e',
  '1f4a0',
  '1f4a5',
  '1f4a6',
  '1f4b0',
  '1f4b8',
  '1f4f7',
  '1f525',
  '1f52e',
  '1f56f',
  '1f576',
  '1f577',
  '1f57a',
  '1f602',
  '1f607',
  '1f608',
  '1f60a',
  '1f60d',
  '1f60e',
  '1f618',
  '1f61a',
  '1f621',
  '1f62d',
  '1f63b',
  '1f648',
  '1f680',
  '1f681',
  '1f6e5',
  '1f6f8',
  '1f6f9',
  '1f914',
  '1f917',
  '1f921',
  '1f929',
  '1f940',
  '1f942',
  '1f943',
  '1f947',
  '1f950',
  '1f95a',
  '1f95b',
  '1f964',
  '1f967',
  '1f970',
  '1f973',
  '1f97a',
  '1f97d',
  '1f981',
  '1f984',
  '1f989',
  '1f98a',
  '1f98b',
  '1f99a',
  '1f99c',
  '1f9c1',
  '1f9c3',
  '1f9c9',
  '1f9cb',
  '1f9e2',
  '1f9e9',
  '1f9ea',
  '1f9f8',
  '1f9fa',
  '1fa81',
  '1fa84',
  '1fa90',
  '1fa96',
  '1faa9',
  '1faaa',
  '1fab7',
  '1fabb',
  '1fac2',
  '1faf6',
  '2600',
  '2615',
  '26bd',
  '26c4',
  '26d1',
  '2708',
  '2728',
  '2744',
  '2764',
  '2b06',
  '2b50',
]);
